import React, { useRef } from 'react';
import { CSVButton } from './CSVButton';

interface CSVImportProps {
  onImport: (data: string) => void;
  label?: string;
}

export const CSVImport: React.FC<CSVImportProps> = ({ onImport, label }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target?.result as string;
        onImport(text);
      };
      reader.readAsText(file);
    }
    // Reset input so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".csv"
        className="hidden"
      />
      <CSVButton type="import" onClick={handleClick} label={label} />
    </>
  );
};